import styled from 'styled-components'


export const StyledBackground = styled.div`
background: rgb(247, 170, 144);
background: linear-gradient(164deg, rgba(247, 170, 144, 1) 0%, rgba(255, 255, 255, 1) 15%, rgba(255, 255, 255, 1) 85%, rgba(187, 233, 250, 1) 100%);
height:100%;
`